import { render, staticRenderFns } from "./AccessesTitle.vue?vue&type=template&id=899d9562&scoped=true"
import script from "./AccessesTitle.vue?vue&type=script&lang=js"
export * from "./AccessesTitle.vue?vue&type=script&lang=js"
import style0 from "./AccessesTitle.vue?vue&type=style&index=0&id=899d9562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899d9562",
  null
  
)

export default component.exports